import React from "react";
import { SearchTypeEnum } from "@components/YhPageHeader/Types";
import { YhPageHeader } from "@components/YhPageHeader";
import { ReceiverTypeDs, StatusDs } from "@src/types/FmsDs";
import { useNoticeModel } from "./summaryModel";


export function PageHeader() {
    const {
        orgDs,
        searchParam,
        noticeTypeDs,
        onReset,
        onSearch,
        loadData,
        updateSearchParam,
    } = useNoticeModel();

    const searchFields = [

        {
            type: SearchTypeEnum.TreeSelect,
            xxl: 4,
            span: 4,
            placeholder: "发布单位",
            fieldName: "sourceOrgCode",
            size: "small",
            disabled: false,
            treeDs: orgDs
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "公告标题",
            fieldName: "title",
            size: "small",
            disabled: false,
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "公告类型",
            fieldName: "noticeTypeCode",
            size: "small",
            disabled: false,
            options: noticeTypeDs
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "发布范围",
            fieldName: "receiverTypeCode",
            size: "small",
            disabled: false,
            options: ReceiverTypeDs
        },
        {
            type: SearchTypeEnum.Datepicker,
            xxl: 4,
            span: 4,
            placeholder: "发布时间",
            fieldName: "pubTime",
            size: "small",
            disabled: false,
            options: StatusDs
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "阅读状态",
        //     fieldName: "readFlag",
        //     size: "small",
        //     disabled: false,
        //     options: StatusDs
        // },

    ]

    return (
        <YhPageHeader
            title="通知公告"
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={onReset}
        />
    );
}